/*
 *  Mixin that returns general layout rules
 *  used for dashboards. Currently returns
 *  width. Possibly, in the future, might also
 *  return height as well. Based off of 12
 *  column grid.
 *
 *  ex:
 *  group - half     |  group - half
 *  widget - full    |  widget - third * widget - third * widget - third
 *
 *  group - full
 *  widget - 2_thirds * widget - third
 */


    export default {
        getWidth: function(){
            var width = 'col-xs-12';
            if (this.options && this.options.columns) {
                width = 'col-xs-'+this.options.columns;
            }
            return width;
        }
    };

